export default __webpack_public_path__ + "assets/images/a65a7f815e65672c6815cc840bcc8c2c.png";